/* eslint-disable max-len */
import { useRef } from 'react'
import MultiSelect from 'multiselect-react-dropdown'
import { useHistory } from 'react-router-dom'
import FormState from '../model/FormState'
import TipoEntidade from '../model/TipoEntidade'
import InputAreaDeAtuacao from './InputAreaDeAtuacao'
import { Button } from './button'

export default function FormStep2(
    props: {setTab: any, formState: FormState,
        tipoEntidades: TipoEntidade[], set: any}
) {
    const {
        setTab, formState, tipoEntidades, set
    } = props
    const form = useRef<HTMLFormElement>(null)
    const history = useHistory()

    const fases = [
        { value: 'IDEAÇÃO', label: 'Ideação' },
        { value: 'VALIDAÇAO', label: 'Validação' },
        { value: 'OPERACAO', label: 'Operação' },
        { value: 'TRACAO', label: 'Tração' },
        { value: 'ESCALA', label: 'Escala' }
    ]

    const publicoAlvoList = [
        { value: 'B2B', label: 'Empresas' },
        { value: 'B2B2C', label: 'Empresas e consumidores finais' },
        { value: 'B2C', label: 'Consumidor final' },
        { value: 'P2P', label: 'Peer-to-peer' },
        { value: 'B2S', label: 'Startups' }
    ]

    function tiposToOptions() {
        return tipoEntidades.map((t) => {
            return { name: t.nome, id: t.id }
        })
    }

    const onSubmit = (event: any) => {
        event.preventDefault()
        if (form?.current?.checkValidity() !== false) {
            setTab(3)
        }
        form?.current?.classList.add('was-validated')
    }

    const voltar = () => {
        setTab(1)
    }

    const cancelar = () => {
        history.push('/buscar')
    }

    return (
        <form noValidate onSubmit={onSubmit} ref={form}>
            <div className="form-row">
                <div className="col-md-7 mb-3">
                    <label htmlFor="inputAreaDeAtuacao">
                        Área de atuação
                    </label>
                    <InputAreaDeAtuacao
                        id="inputAreaDeAtuacao"
                        placeholder="Adicione áreas de atuação"
                        list={formState.areaDeAtuacao}
                        onChange={(l: any) => {set('setAreaDeAtuacao', l)}}
                    />
                    <input
                        type="text"
                        className="form-control hidden"
                        value={formState.areaDeAtuacao.toString()}
                        onChange={() => {}}
                        required
                    />
                    <div className="invalid-feedback">
                        Adicione pelo menos uma área de atuação
                    </div>
                </div>
                <div className="col-md-5 mb-3">
                    <label htmlFor="inputTipoEntidade">
                        Tipo de entidade
                    </label>
                    <MultiSelect
                        options={tiposToOptions()}
                        selectedValues={formState.tipoEntidade}
                        onSelect={
                            (value) => {set('setTipoEntidade', value)}
                        }
                        onRemove={
                            (value) => {set('setTipoEntidade', value)}
                        }
                        displayValue="name"
                        placeholder="Selecione"
                        emptyRecordMsg="Sem opções disponíveis"
                        avoidHighlightFirstOption
                        style={{
                            chips: {
                                background: '#1A3549'
                            },
                            optionContainer: {
                                fontSize: '.9rem'
                            }
                        }}
                    />
                    <input
                        type="text"
                        className="form-control hidden"
                        value={formState.tipoEntidade.toString()}
                        onChange={() => {}}
                        required
                    />
                    <div className="invalid-feedback">
                        Informe pelo menos um tipo de entidade
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-3 mb-3">
                    <label htmlFor="inputEquipe">
                        Tamanho da equipe
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        id="inputEquipe"
                        placeholder="Tamanho da equipe"
                        value={formState.tamanhoEquipe}
                        onChange={
                            (e) => {set('setTamanhoEquipe', e.target.value)}
                        }
                        required
                        maxLength={7}
                        min={0}
                    />
                    <div className="invalid-feedback">
                        Informe um tamanho válido
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <label htmlFor="inputFaturamento">
                        Faturamento
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        id="inputFaturamento"
                        placeholder="Faturamento"
                        value={formState.faturamento}
                        onChange={
                            (e) => {set('setFaturamento', e.target.value)}
                        }
                        required
                        maxLength={10}
                        min={0}
                    />
                    <div className="invalid-feedback">
                        Informe o faturamento
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <label htmlFor="inputFase">
                        Fase
                    </label>
                    <select
                        className="form-control"
                        id="inputFase"
                        value={formState.fase}
                        onChange={
                            (e) => {set('setFase', e.target.value)}
                        }
                        required
                    >
                        <option value="" key="fase">Selecione</option>
                        {
                            fases.map((fase) => {
                                return (
                                    <option
                                        key={fase.value}
                                        value={fase.value}
                                    >
                                        {fase.label}
                                    </option>
                                )
                            })
                        }
                    </select>
                    <div className="invalid-feedback">
                        Selecione a fase
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <label htmlFor="inputPublicoAlvo">
                        Público alvo
                    </label>
                    <select
                        className="form-control"
                        id="inputPublicoAlvo"
                        value={formState.publicoAlvo}
                        onChange={
                            (e) => {set('setPublicoAlvo', e.target.value)}
                        }
                        required
                    >
                        <option value="" key="alvo">Selecione</option>
                        {
                            publicoAlvoList.map((pAlvo) => {
                                return (
                                    <option
                                        key={pAlvo.value}
                                        value={pAlvo.value}
                                    >
                                        {pAlvo.label}
                                    </option>
                                )
                            })
                        }
                    </select>
                    <div className="invalid-feedback">
                        Selecione o público alvo
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-12 mb-3">
                    <label htmlFor="inputMetas">
                        Metas
                    </label>
                    <textarea
                        className="form-control"
                        id="inputMetas"
                        placeholder="Metas"
                        value={formState.metas}
                        onChange={(e) => {set('setMetas', e.target.value)}}
                        required
                        minLength={10}
                    />
                    <div className="invalid-feedback">
                        Informe uma ou mais metas
                    </div>
                </div>
            </div>
            <div className="form-row justify-content-end mt-2">
                <button type="button" onClick={cancelar} className="btn mr-2">Cancelar</button>
                <button type="button" onClick={voltar} className="btn mr-2">Voltar</button>
                <Button type="submit" className="ml-2">
                    Próximo
                    <i className="fas fa-chevron-right fa-sm ml-2" />
                </Button>
            </div>
        </form>
    )
}
